import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, styled, TableCell, TableRow } from "@mui/material";
import { SelectFieldOption } from "controls/global/select-field/SelectInput";
import ComboBoxInput from "controls/global/combo-box-field/ComboBoxInput";
import { borderSize, colors, fontFamily, fontSize, padding } from "theme/defaultStyle";
import theme from "theme/default";

interface SpecialRisksGridRowProps {
  schema: string;
  hasError: boolean;
  index: number;
  specialRisk: any;
  specialRiskOptions?: SelectFieldOption[];
  handleOnRemove: (id: string) => void;
  handleSpecialRiskChange: (id: string, value: string) => void;
  disabled: boolean;
  disableDelete: boolean;
}

const SpecialRisksTableRow = styled(TableRow)({
  borderBottom: `${borderSize.xsmall} solid ${colors.grey17}`,
  "& .MuiTableCell-root": {
    borderBottom: borderSize.zero,
  },
  "& .cell": {
    borderRight: `${borderSize.xsmall} solid ${colors.grey04}`,
    padding: `${padding.zero} !important`,
  },
  "& .disabledIconButton": {
    opacity: 0.5,
  },
});

const StyledTableCell = styled(TableCell)({
  minWidth: 340,
  "& .MuiInputBase-root.MuiInput-root.MuiAutocomplete-inputRoot": {
    border: "none",
  },
  "& .MuiInputBase-root.MuiInput-root.MuiAutocomplete-inputRoot.Mui-focused": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input": {
    fontFamily: `${fontFamily.inter} !important`, 
  },
  "& .MuiInputBase-input::placeholder": { 
    fontSize: fontSize.large,
    fontFamily: `${fontFamily.inter} !important`, 
  },  
});

const SpecialRisksGridRow = ({
  schema,
  hasError,
  index,
  specialRisk: currentSpecialRisk,
  specialRiskOptions,
  handleSpecialRiskChange,
  handleOnRemove,
  disabled,
  disableDelete,
}: SpecialRisksGridRowProps) => {
  const isRowEmpty = (): boolean => {
    return !currentSpecialRisk || !currentSpecialRisk.selectedSpecialRisk;
  };

  return (
    <>
      <SpecialRisksTableRow>
        <StyledTableCell classes={{ sizeSmall: "cell" }}>
          <ComboBoxInput
            label=""
            size="small"
            noBorder
            placeholder="Select or Type Special Risks*"
            name={`specialRisk-${index}`}
            value={currentSpecialRisk.selectedSpecialRisk || ""}
            onChange={(_e: any, value: any) => {
              handleSpecialRiskChange(currentSpecialRisk.id, value);
            }}
            options={specialRiskOptions || []}
            hasError={hasError}
            disabled={disabled}
            showOutsideError={false}
            customStyling={{
              '& .MuiInputBase-input': {
                '&::placeholder': {
                  color: colors.grey22,
                  fontSize: fontSize.medium,
                },
              },
            }}
          />
        </StyledTableCell>

        <TableCell
          classes={{ sizeSmall: "cell" }}
          style={{ width: 60 }}
          align="center"
        >
          <IconButton
            // classes={{
            //   disabled: "disabledIconButton",
            // }}
            disabled={disableDelete || disabled || isRowEmpty()}
            aria-label="delete-special-risk"
            onClick={() => handleOnRemove(currentSpecialRisk.id)}
            sx={{
              color: colors.blue01,
              "&.Mui-disabled": {
                color: colors.blue12,
              },
            }}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </SpecialRisksTableRow>
    </>
  );
};

export default SpecialRisksGridRow;
